import { render, staticRenderFns } from "./CaseStudyParent.vue?vue&type=template&id=902b5238&"
import script from "./CaseStudyParent.vue?vue&type=script&lang=js&"
export * from "./CaseStudyParent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports